import React, { Suspense } from 'react';
import ErrorScreen from '../../../common/ErrorScreen';
import { useDisplayWidgetContext } from '../utils/context';
import CarouselView from '../../carousel/carousel';
// Lazy loading components
const Badge = React.lazy(() => import('../../badge/Badge'));
// const CarouselView = React.lazy(() => import('../../carousel/carousel'));
const Carousel3d = React.lazy(() => import('../../Carousel3d'));
const CarouselRightPost = React.lazy(() => import('../../CarouselRightPost/CarouselRightPost'));
const Collage = React.lazy(() => import('../../collage/collage'));
const Expandable = React.lazy(() => import('../../Expandale'));
const Feed = React.lazy(() => import('../../feed/Feed'));
const Frame = React.lazy(() => import('../../frame/frame'));
const Grid = React.lazy(() => import('../../grid/grid'));
const Masonry = React.lazy(() => import('../../masonry/masonry'));
const Premium1 = React.lazy(() => import('../../premium1/premium1'));
const Premium2 = React.lazy(() => import('../../premium2/premium2'));
const SpecialGrid = React.lazy(() => import('../../specialGrid'));
const Stories = React.lazy(() => import('../../stories/stories'));
const Testimonial1 = React.lazy(() => import('../../testimonials/Testimonial1'));
const Testimonial2 = React.lazy(() => import('../../testimonials/Testimonial2'));
const Testimonial3 = React.lazy(() => import('../../testimonials/Testimonial3'));
const Vertical = React.lazy(() => import('../../vertical/vertical'));
const Wall2 = React.lazy(() => import('../../wall/wall2'));
const MiniFrame = React.lazy(() => import('../../miniFrame'));
import { IData } from '../DisplayWidget.container';

const componentMap = {
  grid: Grid,
  vertical: Vertical,
  carousel: CarouselView,
  testimonial1: Testimonial1,
  testimonial2: Testimonial2,
  testimonial3: Testimonial3,
  collage: Collage,
  feed: Feed,
  wall1: CarouselRightPost,
  wall2: Wall2,
  masonry: Masonry,
  carousel3d: Carousel3d,
  expandableImage: Expandable,
  premium1: Premium1,
  premium2: Premium2,
  stories: Stories,
  badge: Badge,
  frame: Frame,
  specialGrid: SpecialGrid,
  miniFrame: MiniFrame,
};

export default function View() {
  const { data }: { albumData: any[]; data: IData } = useDisplayWidgetContext();
  const galleryView = data?.result?.layout?.galleryView;

  const SelectedComponent = componentMap[galleryView];

  // Render components dynamically based on galleryView
  return (
    <Suspense fallback={<div>Loading...</div>}>{SelectedComponent ? <SelectedComponent /> : <ErrorScreen />}</Suspense>
  );
}
